import React from "react";
import { useQuickSightKiro} from "@/hooks/useKiroReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsKiroDashboard from "@/components/organisms/KiroDashboard";

function KiroReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightKiro();

  return (
    <AWSReportsTemplate
      title="AWS Kiro Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsKiroDashboard />
    </AWSReportsTemplate>
  );
}

export default KiroReports;
